export default __webpack_public_path__ + "static/media/DinosaursArmoredReptiles_08.b5afe11e.png";